import { render, staticRenderFns } from "./CloseOnOutsideClick.vue?vue&type=template&id=58dd6782&scoped=true&"
import script from "./CloseOnOutsideClick.vue?vue&type=script&lang=js&"
export * from "./CloseOnOutsideClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd6782",
  null
  
)

export default component.exports